import React from "react";

function VendasCardapio({ reportData, selectedMenu, cardapios }) {
  reportData.forEach((cardapio) => {
    cardapio.totais = cardapio?.vendas.reduce(
      (acc, produto) => {
        acc.total += produto.TOTAL ?? 0;
        acc.qtde += produto.QTDE ?? 0;
        acc.comissao += produto.COMISSAO ?? 0;

        return acc;
      },
      { total: 0, qtde: 0, comissao: 0 }
    );
  });

  return (
    <div className="box-border p-0 m-0 w-full overflow-x-auto">
      {reportData.map((cardapio) => (
        <div
          key={cardapio?.CODIGO || Math.random()}
          className="box-border rounded-lg shadow-lg p-4 gap-4 w-full max-w-full"
          style={{ width: "100vw", maxWidth: "100vw" }}
        >
          <div className="flex flex-col gap-4 justify-start w-full text-center">
            <h2 className="font-Oswald text-lg sm:text-xl">
              {cardapio?.CODIGO
                ? `${cardapio.CODIGO} - ${cardapio.DESCRICAO}`
                : "Sem Cardápio"}
            </h2>
          </div>

          <div className="box-border overflow-x-auto w-full">
            <table className="w-full min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-semibold w-[50%]">
                    Produto
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right text-sm font-semibold w-[25%]">
                    Quantidade
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right text-sm font-semibold w-[25%]">
                    Comissão
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right text-sm font-semibold w-[25%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {cardapio.vendas.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-200"
                  >
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.CODIGO} - {row.DESCRICAO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {row.QTDE}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.COMISSAO).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-gray-300 font-semibold text-sm">
                  <td className="font-Roboto px-4 py-2 border-b">Total</td>
                  <td className="font-Roboto px-4 py-2 border-b text-right">
                    {cardapio.totais.qtde}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-right">
                    {cardapio.totais?.comissao?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-right">
                    {cardapio.totais?.total?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className="box-border overflow-x-auto w-full">
            <table className="w-full min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-semibold w-[60%]">
                    Forma de Pagamento
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-right text-sm font-semibold w-[40%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {cardapio.vendasFormaPgto.map((row, index) => (
                  <tr key={row?.CODFORMAPGTO} className="hover:bg-gray-200">
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.CODFORMAPGTO} - {row.DESCFORMAPGTO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VendasCardapio;
